/**
 * The realm issues roles namespaced per application, kebab-cased:
 *
 *   tg-smes_restaurant-pos:access | :waiter | :operater | :manager | :admin
 *   bb_inv:admin | bb_party:admin | bb_finance:admin        <- other apps
 *
 * while the app talks about them as `Manager`, `SuperAdmin`. Two rules matter here: only
 * roles under this client count (an inventory admin is not a POS admin), and the two
 * spellings must compare equal.
 */
const POS_CLIENT = 'tg-smes_restaurant-pos';

/** `tg-smes_restaurant-pos:super-admin` and `SuperAdmin` both reduce to `superadmin`. */
const bareName = (role: string): string => role.replace(/[-_\s]/g, '').toLowerCase();

/** The POS roles the user holds, as bare names. Roles of other applications are dropped. */
const posRoles = (userRoles: string[] | null | undefined): Set<string> => new Set(
  (userRoles ?? [])
    .filter(role => role.startsWith(`${POS_CLIENT}:`))
    .map(role => bareName(role.slice(POS_CLIENT.length + 1)))
);

/** True when the user holds any one of `allowed` on this application. */
export function hasAnyRole(userRoles: string[] | null | undefined, allowed: string[]): boolean {
  const held = posRoles(userRoles);
  return allowed.some(role => held.has(bareName(role)));
}
